export default __webpack_public_path__ + "static/media/Group 1677.85bb3c51.svg";